import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { endpoints } from '../endpoints';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {
  parametros: any;

  constructor(private http: HttpClient) {
  }

  generarFormulario(id: string, type: boolean = false): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.parametros = { id };

    let url = type ? endpoints.registro.generarFormularioPostProductos : endpoints.registro.generarFormulario;

    return this.http.post(url, JSON.stringify(this.parametros),
      { headers, responseType: 'blob' }).pipe(
        map(response => {
          return response;
        })
      );

  }

  generarDeclaracionComposicionQuimica(composicionQuimica) : Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let url =  endpoints.registro.generarDeclaracionComposicionQuimica;

    return this.http.post(url, JSON.stringify(composicionQuimica),
      { headers, responseType: 'blob' }).pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          throw new Error(error.error.message);
        })
      );
  }

}
